import { render, staticRenderFns } from "./SalesManagement.vue?vue&type=template&id=75c36991"
import script from "./SalesManagement.vue?vue&type=script&lang=ts"
export * from "./SalesManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports